import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Immutable from 'immutable';

import { bindAll } from '@bibliocommons/utils-react';
import ClearableTextField from '@bibliocommons/base-clearable-text-field';

export class URLInput extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleChange(value) {
    this.props.handleWebItemPropertyChange(Immutable.Map({ url: value }));
  }

  clearPreview() {
    this.props.handleWebItemPropertyChange(Immutable.Map({ url: '' }));
  }

  render() {
    return (
      <div className="cp-url-input">
        <FormattedMessage id="user_list_url_label">
          {message => (
            <label htmlFor="list-url" id="list-url-label">
              {message}
            </label>
          )}
        </FormattedMessage>
        <ClearableTextField
          id="list-url"
          labelledById="list-url-label"
          value={this.props.value}
          maxLength={1000}
          handleChange={this.handleChange}
          handleClear={this.clearPreview}
          hideClearButton={!this.props.value}
          inputTestId="web-item-url"
          clearButtonSrText={<FormattedMessage id="ada_label_clear_web_url" />}
          characterCountSrOnly
          focus
        />
      </div>
    );
  }
}

URLInput.propTypes = {
  value: PropTypes.string.isRequired,
  handleWebItemPropertyChange: PropTypes.func.isRequired
};

export default injectIntl(URLInput);
